// Einheitliche Hinweise für Bereiche, die auf die Buchhaltung warten (Entscheidung 12.10.2026):
// Mietkonto, Mieteingang, Mahnwesen, Bankabgleich und Saldo starten gemeinsam mit der Buchhaltung.

export const BUCHHALTUNG_FOLGT = 'Startet mit der Buchhaltung';
export const BUCHHALTUNG_FOLGT_LANG = 'Zahlungen, Mieteingang und Rückstände erscheinen, sobald die Buchhaltung angebunden ist.';
